/** A chrome-less <video>: NEVER shows native controls (no timeline/pause/PiP). */
export function makeVideo(): HTMLVideoElement {
  const v = document.createElement('video');
  v.muted = true;
  v.autoplay = true;
  v.playsInline = true;
  v.controls = false;
  v.preload = 'none';
  v.disablePictureInPicture = true;
  v.setAttribute('controlsList', 'nodownload noplaybackrate nofullscreen noremoteplayback');
  v.setAttribute('disableRemotePlayback', '');
  v.oncontextmenu = (e) => e.preventDefault();
  return v;
}

export function playSafe(v: HTMLVideoElement): void {
  v.play().catch(() => {
    v.muted = true;
    v.play().catch(() => {});
  });
}

/** Snapshot the current frame onto a canvas (used as a poster before detach). */
export function snapshotTo(v: HTMLVideoElement, c: HTMLCanvasElement): boolean {
  try {
    if (!v.videoWidth) return false;
    c.width = v.videoWidth;
    c.height = v.videoHeight;
    c.getContext('2d')?.drawImage(v, 0, 0);
    return true;
  } catch {
    return false;
  }
}
